/**
 * Discovery's true sub-position from its OWN workflow record — the furthest
 * sub-step actually started. Never inferred from later steps: navigation
 * Continue buttons mark later steps COMPLETED regardless of data, so
 * "reached step > 3" does not imply discovery was ever finished.
 */
export const discoverySubStep = (rfq: any): number => {
    const sub = rfq?.workflow?.SUPPLIER_DISCOVERY?.subSteps;
    if (!sub) return 1;
    if (sub.SUPPLIER_REVIEW === 'IN_PROGRESS' || sub.SUPPLIER_REVIEW === 'COMPLETED') return 3;
    if (sub.VALIDATION_AND_RECOMMENDATIONS === 'IN_PROGRESS' || sub.VALIDATION_AND_RECOMMENDATIONS === 'COMPLETED') return 2;
    return 1;
};

export const calculateWorkflowStep = (rfq: any): { step: number; subStep: number } => {
    if (!rfq) return { step: 1, subStep: 1 };
    
    const wf = rfq.workflow || {};
    
    // If legacy currentStep is present, use it
    if (typeof wf.currentStep === 'number' && wf.currentStep > 0) {
        return { step: wf.currentStep, subStep: 1 };
    }

    let step = 1;
    let subStep = 1;

    if (wf.QUOTES_AND_PROPOSALS === 'IN_PROGRESS' || wf.QUOTES_AND_PROPOSALS === 'COMPLETED') {
        step = 5;
    } else if (wf.SUPPLIER_OUTREACH === 'IN_PROGRESS' || wf.SUPPLIER_OUTREACH === 'COMPLETED') {
        step = 4;
    } else if (wf.SOURCING_CRITERIA === 'COMPLETED' || wf.SUPPLIER_DISCOVERY?.status === 'IN_PROGRESS' || wf.SUPPLIER_DISCOVERY?.status === 'COMPLETED') {
        step = 3;
        const sub = wf.SUPPLIER_DISCOVERY?.subSteps || {};
        if (sub.SUPPLIER_REVIEW === 'IN_PROGRESS' || sub.SUPPLIER_REVIEW === 'COMPLETED') {
            subStep = 3;
        } else if (sub.VALIDATION_AND_RECOMMENDATIONS === 'IN_PROGRESS' || sub.VALIDATION_AND_RECOMMENDATIONS === 'COMPLETED') {
            subStep = 2;
        } else {
            subStep = 1;
        }
    } else if (wf.UPLOAD_BOM === 'COMPLETED' || (rfq.boms && rfq.boms.length > 0) || (rfq.analysisData && rfq.analysisData.components && rfq.analysisData.components.length > 0)) {
        step = 2;
    } else {
        step = 1;
    }

    return { step, subStep };
};
